import { Grid, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { compose } from "@reduxjs/toolkit";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import {
  atleastOne,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg
} from "../../../config/messageconstant";

import dayjs from "dayjs";
import { ButtonCompo } from "../../../components/Comman/Button";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import DynamicDetails from "../../../components/dynamicscreens/DynamicDetails";
import { StockTransferJson } from "../../../DynamicFormsJson/Transaction/stockTransfer";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../../Slice/area.slice";
import {
  getBeatBySalesTeamIdAndAreaIdPost,
  getBeatBySalesTeamIdAndLoginPersonAreas,
} from "../../../Slice/beat.slice";
import { setCategoryAndItemForChallan } from "../../../Slice/category.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getRegionNew } from "../../../Slice/region.slice";
import {
  getDriversByStockHolderId,
  getSalesExecutiveByAreaId,
} from "../../../Slice/salesExecutive.slice";
import { getStockholderByAreaIdsForFilter } from "../../../Slice/StackHolder.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import { getStockTransferInOutHeader } from "../../../Slice/stockTransfer.slice";
import { getTalukaByDistrict } from "../../../Slice/taluka.slice";
import { getVanStockTransferByDriver } from "../../../Slice/vanStockTransfer.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import StockTransferFormTable from "./StockTransferFormTable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

class StockTransferForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      beatAssignList: [],
      salesTeamId: "",
      adminFlag: false,
      stockHolderId: "",
      stockFlag: false,
      searchValue: "",
      value: 0,
      total: 0,
      totalOfQty: 0,
      orderList: [],
      vehicleId: "",
      driverId: "",
      vanStockTransferHeaderId: "",
      dynamicMasterData: {
        areaDetail: this.props.areaList.area,
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        stockHolderDetail: this.props.stockHolderList?.stockholderByArea,
        driverDetail: this.props.driverList?.driverByStockHolder,
      },
      areaIds: {},
    };
  }
  async componentDidMount() {
    const { getRegionNew, getAreaByUserType, showLoador, showNotification } =
      this.props;
    const { adminFlag } = this.state;

    if (navigator.onLine) {
      const userTypeId = localStorage.getItem("userTypeId");

      const userId = localStorage.getItem("userId");

      this.setState({
        userId,
      });

      if (this.props.params.id) {
        this.getDataById(this.props.params.id);
      } else {
        if (userTypeId == 1 || userTypeId == 6) {
          showLoador({ loador: true });
          getRegionNew().then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });

          this.setState({
            adminFlag: true,
          });
        } else {
          showLoador({ loador: true });
          getAreaByUserType().then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }

    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getDataById = (id) => {
    const { showLoador, showNotification } = this.props;

    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return { data: {}, success: false };
    }

    showLoador({ loador: true });

    return apiGet({
      url: endpoint.stockTransferInOutHeader + "/" + id,
    }).then(({ data, success }) => {
      showLoador({ loador: false });

      if (!success || data?.error) {
        return { data: {}, success: false };
      }

      const rowData = data.data;
      const stockHolderId = rowData.stockStakeHolder?.id ?? "";

      this.setState({
        fieldData: rowData,
        stockHolderId: stockHolderId,
        vanStockTransferHeaderId: rowData.vanStockTransferHeaderId ?? "",
        fromTransferHolderId: rowData.fromTransferHolderId ?? "",
        toTransferHolderId: rowData.toTransferHolderId ?? "",
        transferNo: rowData.transferNo ?? "",
        DataToSet: [
          {
            xs: 12,
            sm: 4,
            md: 4,
            lg: 4,
            label: "Transfer No",
            value: rowData.transferNo !== null ? rowData.transferNo : "-",
          },
          {
            xs: 12,
            sm: 4,
            md: 4,
            lg: 4,
            label: "Date",
            value: rowData.date !== null ? rowData.date : "-",
          },
          {
            xs: 12,
            sm: 4,
            md: 4,
            lg: 4,
            label: "Stock Holder",
            value:
              rowData.stockStakeHolder !== null &&
                rowData.stockStakeHolder.stockStakeHolderType !== null
                ? rowData.stockStakeHolder.firmName +
                " (" +
                rowData.stockStakeHolder.stockStakeHolderType.prefix +
                ") "
                : "-",
          },
        ],
      });

      showLoador({ loador: true });

      return apiGet({
        url:
          endpoint.categoryLatest +
          "/and-items-with-margin-and-mrp-by-stock-stake-holder?stockStakeHolderId=" +
          stockHolderId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });

        if (!success || !data?.data || data.data?.errorMessage?.error) {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
          return { data: {}, success: false };
        }

        const rowItemData = data.data;
        const stockCalAtBill = localStorage.getItem("stockCalAtBill");
        const stockFlag = stockCalAtBill === "1";
        let row = [];

        if (stockFlag) {
          row = rowItemData.categoryAndItems.map((category) => ({
            ...category,
            total: 0,
            qty: 0,
            productWithMarginAndMrps: category.productWithMarginAndMrps.map(
              (product) => {
                const matchedTransfer = rowData.stockTransferInOutDetails.find(
                  (item) => item.product.id === product.products.id
                );

                let uomConversionValue = matchedTransfer ? (matchedTransfer.product !== null && matchedTransfer.product.uomConversionValue !== null ? matchedTransfer.product.uomConversionValue : "") : "";
                let rate = matchedTransfer ? (matchedTransfer.rate !== null ? matchedTransfer.rate : product.rate) : product.rate;
                let primaryQtyForEditTable = matchedTransfer ? Math.floor(matchedTransfer.primaryQty) : "";
                let secondaryQtyForEditTable = matchedTransfer ? (matchedTransfer.secondaryQty % uomConversionValue) : "";
                return {
                  ...product,
                  rate: rate,
                  uomConversionValue: product.products.uomConversionValue,
                  primaryClosingQty:
                    product.productStockForMobile.primaryClosingQty?.toFixed(
                      2
                    ) ?? "0.00",
                  secondaryClosingQty:
                    product.productStockForMobile.secondaryClosingQty?.toFixed(
                      2
                    ) ?? "0.00",
                  primaryQty: primaryQtyForEditTable,
                  secondaryQty: secondaryQtyForEditTable,
                  qty: 0,
                  freeQty: 0,
                  itemDiscPer: 0,
                  total: 0,
                  totalQty: 0,
                };
              }
            ),
          }));
        } else {
          row = rowItemData.categoryAndItems.map((rowObj) => {
            return {
              ...rowObj,
              total: 0,
              qty: 0,
              productWithMarginAndMrps:
                rowObj.productWithMarginAndMrps.map((product) => {
                  const matchedTransfer = rowData.stockTransferInOutDetails.find(
                    (item) => item.product.id === product.products.id
                  );
                  let uomConversionValue = matchedTransfer ? (matchedTransfer.product !== null && matchedTransfer.product.uomConversionValue !== null ? matchedTransfer.product.uomConversionValue : "") : "";
                  let primaryQtyForEditTable = matchedTransfer ? Math.floor(matchedTransfer.primaryQty) : "";
                  let secondaryQtyForEditTable = matchedTransfer ? (matchedTransfer.secondaryQty % uomConversionValue) : "";
                  return {
                    ...product,
                    uomConversionValue:
                      product.products.uomConversionValue,
                    qty: 0,
                    freeQty: 0,
                    itemDiscPer: 0,
                    total: 0,
                    primaryQty: primaryQtyForEditTable,
                    secondaryQty: secondaryQtyForEditTable,
                    totalQty: 0,
                  };
                }),
            };
          });
        }

        this.setState({ stockFlag });
        this.setCatList({ row });

        return { data: rowData, success: true };
      });
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stockHolderList !== nextProps.stockHolderList) {
      if (
        this.props.stockHolderList?.stockholderByArea !==
        nextProps.stockHolderList?.stockholderByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderDetail: nextProps.stockHolderList?.stockholderByArea,
          },
        });
      }
    }
    if (this.props.driverList !== nextProps.driverList) {
      if (
        this.props.driverList?.driverByStockHolder !==
        nextProps.driverList?.driverByStockHolder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            driverDetail: nextProps.driverList?.driverByStockHolder,
          },
        });
      }
    }
  }

  setCatList = ({ row }) => {
    const { setCategoryAndItemForChallan } = this.props;
    let dataTotal = 0;
    let totalofTotalQty = 0;
    row.map((rowData) => {
      if (rowData.flag == 3) {
        rowData.productWithMarginAndMrps.map((productData) => {
          dataTotal =
            dataTotal +
            (+productData.primaryQty * productData.products.uomConversionValue +
              +productData.secondaryQty) *
            (+productData.rate);
          totalofTotalQty =
            totalofTotalQty +
            +productData.primaryQty * productData.products.uomConversionValue +
            +productData.secondaryQty;
        });
      }
    });

    this.setState({ total: dataTotal, totalOfQty: totalofTotalQty });
    setCategoryAndItemForChallan({ row });
  };

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBody,
      getStockholderByAreaIdsForFilter,
      getDriversByStockHolderId,
      getVanStockTransferByDriver,
      showLoador,
      showNotification,
    } = this.props;
    const { stockHolderId, adminFlag, areaIds } = this.state;
    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (adminFlag) {
        if (data.taluka && data.taluka != "") {
          let talukaJson = {
            talukaIds: data.taluka,
          };
          showLoador({ loador: true });
          await getAreaByTalukaPostBody({ talukaIds: talukaJson }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }
        if (data.area && data.area != "") {
          this.setState({ areaIds: data.area });
          showLoador({ loador: true });
          await getStockholderByAreaIdsForFilter({ areaIds: data.area }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }
        if (data.stockHolder && data.stockHolder != "") {
          this.setState({ stockHolderId: data.stockHolder });

          let areaIdsObj = {
            areaIds: areaIds,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: data.stockHolder,
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      } else {
        if (data.area && data.area != "") {
          let areaIdsObj = {
            areaIds: data.area,
          };

          const userId = localStorage.getItem("userId");

          this.setState({
            stockHolderId: userId,
            areaIds: data.area,
          });
          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: "",
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }

      if (data.driver && data.driver !== null) {
        this.setState({ driverId: data.driver });

        let dateForAPI = dayjs().format("DD-MM-YYYY");

        showLoador({ loador: true });
        await apiGet({
          url:
            endpoint.vehicle +
            "/assign-date-wise?driverId=" +
            data.driver +
            "&date=" +
            dateForAPI,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (data && data.data && data.data.length !== 0) {
              let vehicleId = data.data.id;
              this.setState({ vehicleId });
            }
          } else {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        showLoador({ loador: true });
        await getVanStockTransferByDriver({
          driverId: data.driver,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            this.setState({ vanStockTransferHeaderId: response.id })
            if (response.dataNotPresent) {
              showNotification({
                msg: "challan not found",
                severity: "error",
              });
            } else {
              showLoador({ loador: true });
              apiGet({
                url:
                  endpoint.categoryLatest +
                  "/and-items-with-margin-and-mrp-by-stock-stake-holder?stockStakeHolderId=" +
                  stockHolderId,
              }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success && data.data != null) {
                  const rowItemData = data.data;
                  if (rowItemData.errorMessage.error) {
                    showNotification({
                      msg: rowItemData.errorMessage.message,
                      severity: "error",
                    });
                  } else {
                    let row = [];
                    const stockCalAtBill =
                      localStorage.getItem("stockCalAtBill");
                    this.setState({
                      stockFlag: stockCalAtBill === "1" ? true : false,
                    });
                    if (stockCalAtBill === "1") {
                      row = rowItemData.categoryAndItems.map(
                        (categoryProducObject) => {
                          let rowData = [];
                          let i;
                          let j;
                          let rsLength =
                            categoryProducObject.productWithMarginAndMrps
                              .length;
                          for (i = 0; i < rsLength; i++) {
                            let orderObject = {
                              ...categoryProducObject.productWithMarginAndMrps[
                              i
                              ],
                              rate: categoryProducObject
                                .productWithMarginAndMrps[i].rate,
                              primaryClosingQty:
                                categoryProducObject.productWithMarginAndMrps[
                                  i
                                ].productStockForMobile.primaryClosingQty.toFixed(
                                  2
                                ),
                              secondaryClosingQty:
                                categoryProducObject.productWithMarginAndMrps[
                                  i
                                ].productStockForMobile.secondaryClosingQty.toFixed(
                                  2
                                ),
                              qty: "",
                              freeQty: 0,
                              itemDiscPer: 0,
                              total: 0,
                              primaryQty: "",
                              secondaryQty: "",
                              totalQty: 0,
                            };
                            rowData.push(orderObject);
                          }
                          return {
                            ...categoryProducObject,
                            total: "",
                            qty: 0,
                            productWithMarginAndMrps: rowData,
                          };
                        }
                      );
                      this.setCatList({ row });
                    } else {
                      row = rowItemData.categoryAndItems.map((rowObj) => {
                        return {
                          ...rowObj,
                          total: 0,
                          qty: 0,
                          productWithMarginAndMrps:
                            rowObj.productWithMarginAndMrps.map((product) => {
                              return {
                                ...product,
                                uomConversionValue:
                                  product.products.uomConversionValue,
                                qty: 0,
                                freeQty: 0,
                                itemDiscPer: 0,
                                total: 0,
                                primaryQty: "",
                                secondaryQty: "",
                                totalQty: 0,
                              };
                            }),
                        };
                      });
                      this.setCatList({ row });
                    }
                  }
                } else {
                  showNotification({ msg: serverMsg, severity: "error" });
                }
              });
            }
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  submitHandler = () => {
    const { category } = this.props;
    const {
      stockHolderId,
      vehicleId,
      driverId,
      date,
      fromTransferHolderId,
      toTransferHolderId,
      transferNo,
      vanStockTransferHeaderId,
    } = this.state;

    let dateForSubmit = date ? date : dayjs().format("DD-MM-YYYY");

    let rowList = [];

    let isQtyError = false;


    category.category.map((catData) => {
      if (catData.flag == 3) {
        const filterData = catData.productWithMarginAndMrps.filter(
          (row) => row.totalQty != 0
        );
        rowList = [...rowList, ...filterData];
        return catData;
      }
    });

    if (rowList.length != 0) {

      isQtyError = rowList.some(obj => obj.qtyError);

      const orderList = rowList.map((rowData, index) => {
        let uomConversionValue = rowData.products !== null && rowData.products.uomConversionValue !== null ? rowData.products.uomConversionValue : ""

        return {
          index: index + 1,
          stockStakeHolder: { id: stockHolderId },
          transferNo: transferNo,
          fromTransferHolderId: this.props.params.id ? fromTransferHolderId : stockHolderId,
          toTransferHolderId: this.props.params.id ? toTransferHolderId : driverId,
          date: dateForSubmit,
          product: {
            id: rowData.products !== null ? rowData.products.id : "",
          },
          productName: rowData.products !== null ? rowData.products.name : "",
          primaryQty: rowData.totalQty / uomConversionValue,
          secondaryQty: rowData.totalQty,
          status: 0,
          rate: rowData.rate,
        };
      });

      let dataJson = {};
      if (this.props.params.id) {
        dataJson = {
          id: this.props.params.id,
          vanStockTransferHeaderId: vanStockTransferHeaderId,
          transferNo: transferNo,
          type: 0,
          stockStakeHolder: { id: stockHolderId },
          fromTransferHolderId: fromTransferHolderId,
          toTransferHolderId: toTransferHolderId,
          date: dateForSubmit,
          status: 0,
          stockTransferInOutDetails: orderList,
          inOut: 1, //Dealer out stock to van (In=0 & Out=1)
        };
      } else {
        dataJson = {
          vanStockTransferHeaderId: vanStockTransferHeaderId,
          type: 0,
          stockStakeHolder: { id: stockHolderId },
          fromTransferHolderId: stockHolderId,
          toTransferHolderId: driverId,
          date: dateForSubmit,
          status: 0,
          stockTransferInOutDetails: orderList,
          inOut: 1, //Dealer out stock to van (In=0 & Out=1)
        };
      }

      if (isQtyError) {
        this.props.showNotification({ msg: "Quantity should be less than product stock", severity: "error" });
      } else {
        this.onSubmit(dataJson);
      }
    } else {
      this.props.showNotification({ msg: atleastOne, severity: "error" });
    }
  };

  onSubmit = (dataJson) => {
    console.log(dataJson);
    const { showLoador, showNotification } = this.props;

    if (navigator.onLine) {
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url: this.props.params.id
              ? endpoint.stockTransferInOutHeader + "/" + "edit"
              : endpoint.stockTransferInOutHeader,
            postBody: dataJson,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({
                msg: savemsg,
              });
              this.props.navigate(-1);
            } else {
              showNotification({
                msg: saveFailedMsg,
                severity: "error",
              });
            }
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchValue = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (tableData) => {
    const { searchValue } = this.state;
    return tableData.filter((currentRow) => {
      let isValid = false;
      let productName =
        currentRow.products != null ? currentRow.products.name : "-";
      let stakeHolderUom =
        currentRow.products.stakeHolderUom != null
          ? currentRow.products.stakeHolderUom.name
          : "-";
      if (
        productName &&
        productName
          .toString()
          .toLowerCase()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        stakeHolderUom &&
        stakeHolderUom
          .toString()
          .toLowerCase()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      return isValid;
    });
  };

  render() {
    const {
      matrixData,
      dynamicMasterData,
      DataToSet,
      dayList,
      adminFlag,
      stockFlag,
      value,
      totalOfQty,
      total,
    } = this.state;
    const { category } = this.props;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showSaveBtn={StockTransferJson.showSaveBtn}
            showTitle={StockTransferJson.showTitle}
            screenTitle={StockTransferJson.screenTitle}
            fieldMeta={
              this.props.params.id
                ? []
                : adminFlag
                  ? StockTransferJson.fieldMeta
                  : StockTransferJson.fieldMetaForStockHolder
            }
            showCancel={StockTransferJson.showCancel}
            apiBaseURL={StockTransferJson.apiBaseURL}
            showSaveNextBtn={false}
            saveBtnText={""}
            showSaveBtnMain={false}
            getListById={this.getListById}
            onSave={this.onSearchValue}
            getDataById={this.getDataById}
          />

          {category.category.length != 0 && (
            <>
              <Tabs
                value={value}
                onChange={this.handleChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                aria-label="scrollable force tabs example"
              >
                {category.category.map((catData) => {
                  return (
                    <Tab
                      label={
                        catData.category.name +
                        " ( " +
                        catData.productWithMarginAndMrps.length +
                        " )"
                      }
                    />
                  );
                })}
              </Tabs>
              {category.category.map((catData, index) => {
                return (
                  <TabPanel value={value} index={index}>
                    <LandingScreenHeader
                      screenTitle={""}
                      showSearchBox={true}
                      showTable={true}
                      showFilter={false}
                      showPdfDownload={false}
                      showExcelDownload={false}
                      onSearch={this.onSearchValue}
                    />
                    <StockTransferFormTable
                      tableHead={[
                        {
                          title: "Sr.No.",
                          name: "index",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                        },
                        {
                          title: "Product Name",
                          name: "name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                        {
                          title: "UOM",
                          name: "name",
                          positionCenter: true,
                          showInscreen: true,
                        },
                        {
                          title: "Rate",
                          name: "name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                        {
                          title: "Stock",
                          name: "primaryClosingQty",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                        {
                          title: "Primary Qty",
                          name: "target",
                          placeHolder: "Enter Target",
                          textFieldError: "targetErr",
                          positionCenter: false,
                          showInscreen: true,
                        },
                        {
                          title: "Secondary Qty",
                          name: "target",
                          placeHolder: "Enter Target",
                          textFieldError: "targetErr",
                          positionCenter: false,
                          showInscreen: true,
                        },
                        {
                          title: "Total Qty",
                          name: "target",
                          placeHolder: "Enter Target",
                          textFieldError: "targetErr",
                          positionCenter: false,
                          showInscreen: true,
                        },
                        {
                          title: "Total",
                          name: "name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                      ]}
                      data={this.getFilteredTableData(
                        catData.productWithMarginAndMrps
                      )}
                      rowList={category.category}
                      setList={this.setCatList}
                      flag={stockFlag}
                    />
                  </TabPanel>
                );
              })}
              <br />
              <DynamicDetails
                DataToSet={[
                  {
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    label: "Total",
                    value: total.toFixed(2),
                  },
                  {
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    label: "Total Quantity",
                    value: totalOfQty,
                  },
                ]}
              />

              <Grid container spacing={1}>
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  sx={{ justifyContent: "flex-end" }}
                >
                  <ButtonCompo
                    size="medium"
                    type="submit"
                    variant="contained"
                    name={"Submit"}
                    onClick={this.submitHandler}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  stockHolderList: state.stackholder,
  driverList: state.salesExecutive,
  category: state.category,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getStateByRegion,
  getAreaByUserType,
  getSalesExecutiveByAreaId,
  getBeatBySalesTeamIdAndLoginPersonAreas,
  getBeatBySalesTeamIdAndAreaIdPost,
  getAreaByTalukaPostBody,
  getStockholderByAreaIdsForFilter,
  getDriversByStockHolderId,
  setCategoryAndItemForChallan,
  getVanStockTransferByDriver,
  getStockTransferInOutHeader,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(StockTransferForm);
